import react from "react";

export const StatusRow = ({ label, value, total }) => {
  const percent = total ? Math.round((value / total) * 100) : 0;
  return (
    <div>
      <div className="flex justify-between text-xs mb-1">
        <span className="font-medium text-slate-700">{label}</span>
        <span className="text-slate-500">
          {value}/{total} ({percent}%)
        </span>
      </div>
      <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-2 bg-blue-500 rounded-full"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};